<template>
    <el-dialog v-dialogDrag class="dialog" width="550px" :visible.sync="dialogVisible" v-loading="dialoading" :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑组织机构
            </div>
        </div>

        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading" label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="部门名称" prop="departmentName" required>
                    <el-input  v-model="form.departmentName" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="上级部门" prop="parentName">
                    <selectTree  v-model="tree_model" :rowKeys="treekeys" :tree-data="treeData" :isMulti="false"
                                placeholder="请选择上级部门"></selectTree>
                </el-form-item>
                <el-form-item label="负责人">
                    <el-input  v-model="form.headMan" placeholder="请选择部门负责人"></el-input>
               </el-form-item>
                <el-form-item label="顺序">
                    <el-input type="number" v-model="form.orderBy"></el-input>
                </el-form-item>
                <el-form-item label="备注" class="bzClass">
                    <el-input
                            resize="none"
                            type="textarea"
                            placeholder="请输入备注"
                            v-model="form.remark"
                            rows="2"
                            show-word-limit>
                    </el-input>
                </el-form-item>

            </el-form>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import selectTree from '@/components/tools/tree/selectTree'
    // import selectTable from '@/components/tools/table/selectTable'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {selectTree},
        data() {
            return {
                tree_model: {
                    id: "",
                    name: ""
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'parentId',
                    children: 'children'
                },

                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px'
            };
        },
        mounted() {
            this.getFolder();
            if(this.formData.parentId === "0"){
                this.formData.parentName = "部门树"
            }
            this.tree_model = {
                id: this.formData.parentId,
                name: this.formData.parentName
            }
        },
        methods: {
            async getFolder() {
                this.dialoading = true;
                let param = {
                    url:"/department/listZTree",
                    param:{
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)

                if (data.infoCode == "0") {
                    const retData = data.data.jsonStr;
                    if(retData){
                        this.treeData = retData;
                    }
                }
                this.dialoading = false;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                this.form.parentId = this.tree_model.id;
                this.form.parentName = this.tree_model.name;

                if(this.$pub.isEmpty(this.form.departmentName)){
                    this.$message({message: '请输入部门名称', type: 'error'});
                    return false;
                }
                if(this.form.orderBy==null){
                    this.$message({message: '请输入显示顺序', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },
        }
    }
</script>

